import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CallOverdueProps from "./call-over-due-popup-props";
import SelectInputComponent from "../select-input-component/select-input-component";
import "../confirmation-popup/popup.scss";
import "./call-over-due-popup.scss";
import ContactLink from "../contact-link/contact-link";
import PhoneIcon from "../../../assets/icons/phone.svg";
import AvatarIcon from "../../../assets/icons/avatar.svg";
import { isValidPhoneNumber } from "../../../utils/utils";

const CallOverDuePopup: React.FC<CallOverdueProps> = ({
  title,
  open,
  onCancel,
  onOkay,
  className,
  isDoNotSendButtonRequired = false,
  extraButtonText,
  onExtraButtonOkay,
  details,
  selectedCallStatus,
  setSelectedCallStatus,
  isCustomer = false,
}) => {
  const callOptions = [
    {
      label: "Mark As Completed",
      value: "Mark As Completed",
      id: 1,
    },
    // {
    //   label: "Reschedule Call",
    //   value: "Reschedule Call",
    //   id: 2,
    // },
    {
      label: "Cancel Call",
      value: "Cancel Call",
      id: 3,
    },
  ];

  return (
    <Dialog
      open={open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className={`confirmation-call-due-popup-wrapper ${className || ""}`}
    >
      <DialogTitle id="alert-dialog-title">
        <div className="header-wrapper">
          <div>{title}</div>
        </div>
      </DialogTitle>

      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <div className="call-popup-content">
            {/* Left: Profile */}
            <div className="profile-column">
              <img
                src={
                  details?.lead_profile_file_Url || details?.customer_profile_file_Url || AvatarIcon
                }
                className="profile-image"
              />
            </div>

            {/* Right: Details */}
            <div className="details-column">
              <div className="details-item">
                <div className="name-text">
                  {details?.first_name || ""} {details?.middle_name || ""}{" "}
                  {details?.last_name || ""}
                </div>
              </div>

              <div className="details-item">
                <span className="label">{isCustomer ? "Customer Owner" : "Lead Owner"}</span>
                <span className="value">
                  {isCustomer
                    ? `${details?.customerOwner?.first_name || ""} ${details?.customerOwner?.last_name || ""}`
                    : `${details?.owner?.first_name || ""} ${details?.owner?.last_name || ""}`}
                </span>
              </div>

              <div className="details-item">
                <span className="label email-label">Email</span>
                <ContactLink
                  type="Email"
                  value={details?.primary_email_address || "-"}
                  id={details?.primary_email_address}
                />
              </div>

              <div className="details-item">
                <span className="label">Phone</span>
                <span className="contact-item phone-item">
                  {!details?.primary_phone_number ||
                    details.primary_phone_number === "null" ||
                    !isValidPhoneNumber(details.primary_phone_number) ? (
                    "-"
                  ) : (
                    <ContactLink
                      type="Phone"
                      value={details.primary_phone_number}
                      id={details?.id}
                    />
                  )}
                  <img src={PhoneIcon} alt="Phone" className="contact-icon" />
                </span>
              </div>

              <div className="details-item">
                <span className="label">{isCustomer ? "Customer Status" : "Lead Status"}</span>
                <span className="value">
                  {isCustomer ? "Closed-Won" : details?.lead_status || "-"}
                </span>
              </div>
            </div>
          </div>
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        {!isCustomer && (
          <div className="call-options-wrapper">
            <SelectInputComponent
              options={callOptions}
              placeholder="Select Action"
              onChange={(value: any) => {
    
                // setSelectedCallStatus(value);
                onOkay(value);
              }}
              value={selectedCallStatus}
            />
          </div>
        )}
        <Button onClick={onCancel} className="cancel-btn">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CallOverDuePopup;
